import { createTheme } from "@mui/material/styles";
import { mono as fontPrimary } from "./fonts";

const WebTheme = createTheme({
  palette: {
    primary: {
      main: "#43CED7",
      whiteCard: "#fff",
      grayCard: "#F1F4FA",
      blackText: "#3A4752",
      redText: "rgba(209, 9, 9, 1)",
      lightRed: "rgba(209, 9, 9, 0.2)",
      greenText: "rgba(3, 168, 158, 1)",
      grayText: "#768B9E",
      whiteText: "#fff",
      blueText: "#0085E5",
      blueCard: "#0085E5",
      lightBlue: "rgb(0 133 229 / 16%)",
      lightGreen: "rgb(180 242 236)",
      background: "#eef0f4",
      inputBorder: "#e2e8f0",
      lightPink: "rgba(255, 240, 244, 1)",
    },
  },
  typography: {
    fontFamily: fontPrimary,
    h3: {
      fontFamily: fontPrimary,
      fontWeight: 600,
      fontSize: "1rem",
      color: "#0f172a",
    },
  },
  components: {
    MuiTypography: {
      defaultProps: {},
      styleOverrides: {
        blackOpacity: {
          color: "#222",
          opacity: 0.5,
        },
      },
    },
    MuiContainer: {
      styleOverrides: {
        root: ({ theme, ownerState }) => ({
          margin: "auto",
          maxWidth: "1300px",
          Width: "100%",
          ...(ownerState?.noQuery && {
            [theme.breakpoints.up("lg")]: {
              maxWidth: "1300px",
              Padding: "0px !important",
            },
            [theme.breakpoints.up("sm")]: {
              maxWidth: "100%",
              Padding: "0px !important",
            },
            [theme.breakpoints.up("md")]: {
              maxWidth: "1300px",
              Padding: "0px !important",
            },
          }),
          ...(ownerState?.notMargin && {
            margin: "0px",
          }),
        }),
      },
    },
    MuiButton: {
      styleOverrides: {
        root: ({ ownerState }) => ({
          fontFamily: fontPrimary,
          mixBlendMode: "normal",
          borderRadius: "6px",
          fontSize: "14px",
          textTransform: "none",
          boxShadow: "none",
          transition: "all 0.2s ease",
          ...(ownerState.variant === "primary" && {
            color: "white",
            fontWeight: 500,
            background: "#0085E5",
            "&:hover": {
              background: "#0074cc",
              boxShadow: "0 2px 8px rgba(0, 133, 229, 0.25)",
            },
          }),
          ...(ownerState.variant === "secondary" && {
            color: "white",
            fontWeight: 500,
            background: "#0085E5",
            "&:hover": {
              background: "#0074cc",
              boxShadow: "0 2px 8px rgba(0, 133, 229, 0.25)",
            },
          }),
          ...(ownerState.variant === "disabled" && {
            color: "#fff !important",
            fontWeight: "normal",
            background: "#cbd5e1",
          }),
          ...(ownerState.variant === "danger" && {
            background: "#fef2f2",
            color: "#b91c1c",
            border: "1px solid #fecaca",
            fontWeight: 500,
            "&:hover": {
              background: "#fee2e2",
            },
          }),
          ...(ownerState.variant === "outlined" && {
            background: "transparent",
            color: "#3A4752",
            border: "1px solid #e2e8f0",
            fontWeight: 500,
            "&:hover": {
              border: "1px solid #cbd5e1",
              background: "#f8fafc",
            },
          }),
          ...(ownerState.variant === "loginWithGoogle" && {
            background: "transparent",
            color: "#3A4752",
            border: "1px solid #e2e8f0",
            fontWeight: 500,
            "&:hover": {
              border: "1px solid #cbd5e1",
              background: "#f8fafc",
            },
          }),
        }),
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: "#cbd5e1",
          "&.Mui-checked": {
            color: "#0085E5",
          },
        },
      },
    },
  },
});

export default WebTheme;
